import { Button, CardHeader, CircularProgress, Dialog, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import { withStyles } from "@mui/styles";
import axios from "axios";
import * as React from "react";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { IRouteProps } from "../LayoutWrapper";

interface FilesPageStates {
    activeType: string;
    loading: boolean;
    exportingBundle: boolean;
    sheetUrl: string;
    fileId: string | null;
    logs: any[];
    pendingList: any[];
    pendingListFetched: boolean;
    showHistoryDialog: boolean;
    exportHistory: any[];
    historyLoading: boolean;
}

class BundleExporterWrapped extends React.Component<IRouteProps, FilesPageStates> {
    initialExportInterval: any;

    constructor(props) {
        super(props);

        this.state = {
            activeType: props.match.params.type,
            loading: true,
            exportingBundle: false,
            sheetUrl: "",
            fileId: null,
            logs: [],
            pendingList: [],
            pendingListFetched: false,
            showHistoryDialog: false,
            historyLoading: false,
            exportHistory: [],
        };
    }

    componentDidMount() {
        this.fetchExportQueue();

        this.initialExportInterval = setInterval(() => {
            this.fetchExportQueue();
        }, 5000);

        if (this.props.socket) {
            this.props.socket.on("BundleExporterUpdate", data => {
                console.log(data);

                if (data.fileId === this.state.fileId) {
                    this.setState({
                        logs: [...this.state.logs, {
                            id: Math.random(),
                            date: new Date(),
                            ...data,
                        }]
                    });
                }
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.initialExportInterval);
    }

    fetchExportQueue = async () => {
        try {
            // Put data to S3
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/bundle/export_queue`, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            this.setState({
                pendingList: response.data.list,
                pendingListFetched: true
            });
        } catch (error) {
            PopupMessage.error("Couldn't fetch export queue");
        }
    }

    changeSheetUrl = (e) => {
        this.setState({
            sheetUrl: e.target.value,
        });
    }

    hideHistoryDialog() {
        this.setState({
            showHistoryDialog: false,
        })
    }

    exportBundle = async () => {
        const fileId = this.state.sheetUrl.split("/")[5];

        this.setState({ exportingBundle: true, fileId, logs: [] });

        try {
            await axios({
                method: "post",
                url: `${Config.getInstance.apiUrl}/api/bundle/export_from_drive`,
                timeout: 900000,
                data: {
                    fileId,
                    exporterUserId: this.props.activeUser.userId,
                },
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            this.setState({ exportingBundle: false });

            this.fetchExportQueue();
        } catch (error) {
            PopupMessage.error("Couldn't start export");
        }

        // Trigger mavia Arena export for localization file
        if (
            fileId.includes("1lnXg_HvHH_hq9jJZmS8Ie6bztCsZwwCOxbGH8oKFOr8") &&
            !Config.getInstance.apiUrl.includes(Config.getInstance.config.arena.address)
        ) {
            try {
                await axios({
                    method: "post",
                    url: `https://${Config.getInstance.config.arena.address}/api/bundle/export_from_drive`,
                    timeout: 900000,
                    data: {
                        fileId,
                        exporterUserId: this.props.activeUser.userId,
                    },
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                });
            } catch (error) {
                PopupMessage.error("Couldn't start export for mavia Arena");
            }
        }
    }

    formatFileName = (historyItem) => {
        if (historyItem.bundle_object && historyItem.bundle_object.key) {
            return historyItem.bundle_object.key;
        }

        if (historyItem.custom_exporter && historyItem.custom_exporter.key) {
            return historyItem.custom_exporter.key;
        }

        if (historyItem.custom_exporter && historyItem.custom_exporter.name) {
            return historyItem.custom_exporter.name;
        }

        return historyItem.sheet_id;
    }

    render() {
        const { classes } = this.props;

        return <div className="contentPadding">
            <Paper elevation={0}>
                <CardHeader title="Export Queue"/>

                <Paper elevation={0}>
                    {this.state.pendingList.length > 0 && <Table aria-label="simple table" style={{ marginBottom: 20, tableLayout: "inherit" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>File</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Started by</TableCell>
                                <TableCell>Created At</TableCell>
                                <TableCell>Started At</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.pendingList.map(pendingItem => (
                                <TableRow key={pendingItem.file_id + pendingItem.created_at}>
                                    <TableCell component="th" scope="row">
                                        <a href={`https://docs.google.com/spreadsheets/d/${pendingItem.file_id}/edit`} target="_blank">
                                            {pendingItem.file_id}
                                        </a>
                                    </TableCell>
                                    <TableCell align="left">{pendingItem.status}</TableCell>
                                    <TableCell align="left">{pendingItem.user.full_name}</TableCell>
                                    <TableCell align="left">{new Date(pendingItem.created_at).toLocaleString()}</TableCell>
                                    <TableCell align="left">{pendingItem.started_at ? new Date(pendingItem.started_at).toLocaleString() : "-"}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>}

                    {this.state.pendingList.length === 0 && <div style={{ padding: "10px 15px" }}>
                        <Alert severity="info">No exports in the queue</Alert>
                    </div>}
                </Paper>
            </Paper>

            <Paper className="root" style={{ marginTop: 20, paddingBottom: 10 }} elevation={0}>
                <div style={{ float: "left", width: "100%" }}>
                    <div style={{ float: "left", padding: "15px 22px 15px 22px", width: "100%" }}>
                        <TextField
                            id="standard-full-width"
                            label="Google sheets URL"
                            style={{ margin: 8 }}
                            placeholder="e.g. https://docs.google.com/spreadsheets/d/1lnXg_HvHH_hq9jJZmS8Ie6bztCsZwwCOxbGH8oKFOr8/edit#gid=674619185"
                            fullWidth
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={this.changeSheetUrl}
                            value={this.state.sheetUrl}
                        />

                        <div className={classes.wrapper}>
                            <Button disableElevation
                                onClick={this.exportBundle}
                                disabled={this.state.sheetUrl.length === 0 || this.state.exportingBundle}
                                className={classes.loadingButton}
                                color="primary"
                                size="medium"
                                variant="contained"
                            >
                                Export
                            </Button>

                            {this.state.exportingBundle && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </div>

                        {this.state.fileId &&
                            <div className="terminal--logs full-width">

                                <div className="fakeScreen">
                                    {this.state.logs.map(log => <p className={`line ${log.error ? "have-error" : ""}`} key={log.id}>
                                        <span style={{ paddingRight: 10 }}>
                                            [{Helpers.formatDateTime(log.date || new Date(), true)}]
                                        </span>

                                        {log.error && "[Error] "}
                                        {log.action}
                                        {log.file && <span style={{ paddingLeft: 7 }}>: {log.file}</span>}
                                    </p>)}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Paper>

            <Dialog
                fullWidth={true}
                maxWidth="md"
                open={this.state.showHistoryDialog}
                onClose={() => this.hideHistoryDialog()}
            >
                <DialogTitle>Export history</DialogTitle>
                <DialogContent>
                    {this.state.historyLoading &&
                        <div style={{ textAlign: "center", width: "100%" }}>
                            <CircularProgress />
                        </div>
                    }

                    {!this.state.historyLoading && <Table aria-label="simple table" style={{ marginBottom: 20, tableLayout: "inherit" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>File</TableCell>
                                <TableCell>User</TableCell>
                                <TableCell>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.exportHistory.map(historyItem => (
                                <TableRow key={historyItem.id}>
                                    <TableCell component="th" scope="row">{this.formatFileName(historyItem)}</TableCell>
                                    <TableCell align="left">{historyItem?.user?.full_name || "Unknown"}</TableCell>
                                    <TableCell align="left">{new Date(historyItem.created_at).toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>}
                </DialogContent>
            </Dialog>
        </div>;
    }
}

const styles: any = theme => ({
    wrapper: {
        margin: 8,
        position: "relative",
        marginTop: 10,
        width: 150,
    },
    loadingButton: {
        width: "100%",
    },
    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
});

export const BundleExporter = withStyles(styles)(BundleExporterWrapped);
